export const SET_TECHNICIANS = "technicians/SET_TECHNICIANS";
export const SET_IS_FETCHING_TECHNICIANS =
  "technicians/SET_IS_FETCHING_TECHNICIANS";
export const RESET_IS_FETCHING_TECHNICIANS =
  "technicians/RESET_IS_FETCHING_TECHNICIANS";
export const CLEAR_TECHNICIANS = "technicians/CLEAR_TECHNICIANS";
export const INVITE_TECHNICIANS = "technicians/INVITE_TECHNICIANS";
export const ADD_TECHNICIANS = "technicians/ADD_TECHNICIANS";
export const GET_TECHNICIANS_REQUEST = "technicians/GET_TECHNICIANS_REQUEST";
export const REMOVE_TECHNICIAN_REQUEST =
  "technicians/REMOVE_TECHNICIAN_REQUEST";
export const REMOVE_TECHNICIAN = "technicians/REMOVE_TECHNICIAN";
export const GET_IS_REGISTRATION_CODE_VALID_REQUEST =
  "technicians/GET_IS_REGISTRATION_CODE_VALID_REQUEST";
export const SET_IS_REGISTRATION_CODE_VALID =
  "technicians/SET_IS_REGISTRATION_CODE_VALID";
export const RESET_IS_REGISTRATION_CODE_VALID =
  "technicians/RESET_IS_REGISTRATION_CODE_VALID";



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/technicians/actionTypes.ts